export const EDITOR_HOST_ERROR_CODES = [
  "invalid_document_ref",
  "invalid_selection_snapshot",
  "load_failed",
  "disposed",
  "viewer_unimplemented",
] as const;

export type EditorHostErrorCode = (typeof EDITOR_HOST_ERROR_CODES)[number];

export class EditorHostError extends Error {
  readonly code: EditorHostErrorCode;
  readonly details: Record<string, unknown>;

  constructor(
    code: EditorHostErrorCode,
    message: string,
    details: Record<string, unknown> = {},
  ) {
    super(message);
    this.name = "EditorHostError";
    this.code = code;
    this.details = details;
  }
}

export function isEditorHostError(value: unknown): value is EditorHostError {
  return value instanceof EditorHostError;
}
